import React from "react";

const EmpresasAdminSearch = ({ filters, setFilters }) => {
    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="flex flex-col md:flex-row gap-4 mb-4">
            <input
                type="text"
                placeholder="Buscar por empresa"
                name="empresa"
                value={filters.empresa}
                onChange={handleChange}
                className="border p-2 rounded w-full md:w-1/3"
            />
            <input
                type="text"
                placeholder="Buscar por RFC"
                name="rfc"
                value={filters.rfc}
                onChange={handleChange}
                className="border p-2 rounded w-full md:w-1/3"
            />
        </div>
    );
};

export default EmpresasAdminSearch;